new Vue({
    el: '#consumer-loan',
    data: {
        fullname: null,

        phone: null,
        hasIncome: null,

        pins: [],

        intro: null,
        terms: null,

        selectedPin: null,


        isSubmited: false,
        result: false,
        resultMessage: null,
        sendingData: false,

        anotherProductCheckbox: false,
        anotherClaimTypeCheckbox: false,

        agreeTerms: false,
        reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
    },
    methods: {
        send: function (e) {
            e.preventDefault();
            var _this = this;
            if (_this.sendingData) { return; }
            _this.isSubmited = true;
            _this.resultMessage = null;
            valid = true;
            if (!_this.fullname || !_this.phone || !_this.selectedPin || !_this.agreeTerms) {
                valid = false;
            }
            if (valid) {
                _this.sendingData = true;
                axios.post('~/api/consumerloan/send',
                    {
                        fullname: _this.fullname,
                        phone: _this.phone,
                        branch: _this.selectedPin['title'],
                        branchId: _this.selectedPin['id'],
                        captchaVal: $("#g-recaptcha-response").val(),
                        languageId: window.languageId
                    }).then(function (response) {
                        _this.result = response.data.success;
                        _this.resultMessage = response.data.message;
                    }).catch(function (e) {
                        _this.result = false;
                        _this.resultMessage = window.errorPhrase;
                    }).finally(function (e) {
                        _this.sendingData = false;
                    });
            }
            _this.isSubmited = true;

            return false;
        }
    },
    mounted: function () {
        var _this = this;
        if (!!window.consumerLoanFormSettings) {
            _this.pins = window.consumerLoanFormSettings.pins;
        }
    }
})